import type {
  UpdateActivityStatus,
  UpdateActivityStatusPayload,
} from './typings'

export const updateActivityStatusActionCreator = (
  payload?: UpdateActivityStatusPayload,
): UpdateActivityStatus => ({
  type: 'activities/updateActivityStatus',
  payload,
})
